import { render, staticRenderFns } from "./DrugSalesStat.vue?vue&type=template&id=226dd3a2&scoped=true"
import script from "./DrugSalesStat.vue?vue&type=script&lang=js"
export * from "./DrugSalesStat.vue?vue&type=script&lang=js"
import style0 from "./DrugSalesStat.vue?vue&type=style&index=0&id=226dd3a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226dd3a2",
  null
  
)

export default component.exports